import React from 'react'
import FormViewer from '../../components/FormViewer';
import LoaderButton from '../../components/LoaderButton';
import Responsive from '../../components/Responsive';
import { translate } from '../../utils/useful';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import Header from '../../components/header/Header';
import CAHeader from '../../components/header/CAHeader';

class CAStageType extends React.Component {
    state = {
        isLoading: false,

        headers: [
            {
                type: 'ImageSelectInput', key: 'collectionInfo.type', col: 12, information: {

                    type: 'local',
                    col: 2,
                    padding: 10,
                    items: [
                        { title: '{{lang}}Single stage (default)', image: '/assets/icons/useful/flow-1.png', value: 'single', description: '{{lang}}Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },
                        { title: '{{lang}}Multi stage', image: '/assets/icons/useful/workflow.png', value: 'multi', description: '{{lang}}Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },

                    ], placeholder: '', required: true
                },
            },

        ]
    }

    componentDidMount() {
        if (this.props.setHeader) {
            // this.props.setHeader("dummy",1)
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                // 'title': `${this.props.user?.info?.fullname}`,
                isPortal: true, doNotshowNotification: true,
                'title': (this.props.preTitle ? (this.props.preTitle + ' | ') : '') + translate('Stage Type'),
                create: true,
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()

            })
        }

    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    isLoading={this.state.isLoading}
                    onClick={this.nextStage}
                    title={translate("ca.Continue")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }

    nextStage = () => {

        let rawData = this.form.getForm()
        if (rawData) {
            let data = this.props.initData
            if (!data.collectionInfo) {
                data.collectionInfo = {}
            }
            data.collectionInfo.type = rawData.collectionInfo.type
            // let data = { settings: { type: rawData.settings.type } }
            this.props.setData(data, () => {

                if (this.props.continue) {
                    this.props.continue(this.props.stageName)
                } else {

                    if (data.collectionInfo.type == 'single') {
                        this.props.changeStage('access')
                    }
                    else {
                        console.log('multiStage')
                        this.props.changeStage('multiStage')
                    }
                }
            })
        }


    }




    render() {
        return (
            <div className='h-100 w-100 scroll-no-scrollbar overflow-hidden' style={{ position: 'relative', borderBottomRightRadius: '10px' }}>
                <div className='w-100 h-100 position-absolute overflow-hidden '>
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(51, 231, 255, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}>
                    </div>

                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(50, 247, 51, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}>

                    </div>
                </div>
                {/* <div className='w-100' style={{ position: 'relative', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <div className='w-100 flexc flex-column'>
                    <div className='p-3' style={{ maxWidth: 800 }}>

                        <div className='px-0 pt-3 mb-3' style={{}}>
                            <h2 className=" text-semibig mb-0 color-dark-blue-1" >{translate('Workflow type')}</h2>
                            <p className="mt-1 text-small color-dark-blue-1 max-width-500" >{translate("You can change this option later")}</p>
                        </div>

                        <div className='mt-2' >
                            <FormViewer ref={el => this.form = el} initData={this.props.initData} headers={this.state.headers} errors={this.state.errors} inputClass={' single-big  color-dark-blue-1'} nopadding={true} width={this.props.width} />
                        </div>
                        {/* <div className='p-1'>
                            <p style={{ fontSize: '12px', color: "gray" }}>{translate('ca.* You can change this later')}</p>
                        </div> */}

                    </div>
                </div>
            </div>
        )
    }
}

export default CAStageType;